export enum CommonError {
  AlreadyExists = 'Dieser Wert existiert bereits',
  InterviewDatesAreInThePast = 'Vorgeschlagene Daten und Platzhalterdaten müssen in der Zukunft liegen',
  NotEnoughRoles = 'Der Mitarbeiter verfügt nicht über ausreichende Berechtigungen',
  UpdatedToNotSendBecauseJobIsNotValid = 'Auf Nicht senden aktualisiert, da der Auftrag weder veröffentlicht noch offline ist',
  LeadsMustHaveNonLeadRole = 'Leads müssen auch die Nicht-Lead-Rolle haben',
  CandidateDoesntHavePhoneNumber = 'Der Kandidat hat keine Telefonnummer',
  StartTimeMustBeBeforeEndTime = 'Bei Terminvorschlägen für Interviews muss die Startzeit vor der Endzeit liegen.',
  MustHaveInterviewsToAssignCemPriorityAsKam = 'Konnte nicht aktualisiert werden: Keine VTs.',
  Forbidden = 'ra.validation.forbidden',
  SourceDomainsMustBeExclusive = 'ra.validation.sourceDomainsMustBeExclusive',
  DociaSourceDomainChangeRequiresSuperAdmin = 'ra.validation.dociaSourceDomainChangeRequiresSuperAdmin',
  DociaVersionAlreadyExists = 'Es existiert bereits eine Docia-Version.',
  UnexpectedError = 'unexpected_error',
  UnassignCemEmployeeBeforeChangingCemAssignmentStatus = 'cem.errors.unassignCemEmployeeBeforeChangingCemAssignmentStatus',
  AssignCemEmployeeBeforeChangingCemAssignmentStatus = 'cem.errors.assignCemEmployeeBeforeChangingCemAssignmentStatus',
}
